import { useState } from 'react';
import { motion } from 'framer-motion';

interface ProductImageProps {
  images: string[];
  alt: string;
  className?: string;
}

export const ProductImage = ({ images, alt, className = '' }: ProductImageProps) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    if (images.length > 1) {
      setCurrentImage(1);
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setCurrentImage(0);
  };

  return (
    <motion.div
      className={`relative overflow-hidden rounded-lg bg-dark-bg-tertiary ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.3 }}
    >
      <div className="aspect-square relative">
        <motion.img
          key={currentImage}
          src={images[currentImage]}
          alt={alt}
          className="w-full h-full object-cover"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        />

        {/* Overlay gradient on hover */}
        <motion.div
          className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"
          initial={{ opacity: 0 }}
          animate={{ opacity: isHovered ? 1 : 0 }}
          transition={{ duration: 0.3 }}
        />
      </div>
    </motion.div>
  );
};
